import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function AdminFAQ() {
  const [list, setList] = useState([]);
  const [f, setF] = useState({ question: "", answer: "", order: 0, hidden: false });
  const [editing, setEditing] = useState(null);
  const load = () => api.get("/admin/faqs").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);
  const save = async (e) => {
    e.preventDefault();
    const body = { ...f, order: Number(f.order) };
    if (editing) await api.put(`/admin/faqs/${editing}`, body); else await api.post("/admin/faqs", body);
    toast.success("Tersimpan"); setF({ question: "", answer: "", order: 0, hidden: false }); setEditing(null); load();
  };
  const del = async (id) => { if (window.confirm("Hapus?")) { await api.delete(`/admin/faqs/${id}`); load(); } };
  return (
    <div>
      <h1 className="display text-4xl md:text-6xl mb-6">FAQ</h1>
      <div className="grid md:grid-cols-[1fr,380px] gap-6">
        <div className="border border-[color:var(--border)]">
          {list.map((q) => (
            <div key={q.id} className="p-4 border-b border-[color:var(--border)]">
              <div className="flex justify-between"><div className="font-medium">{q.question}</div>
                <div className="space-x-2 text-xs"><button onClick={() => { setEditing(q.id); setF(q); }} className="underline">Edit</button><button onClick={() => del(q.id)} className="underline text-[color:var(--accent)]">Delete</button></div></div>
              <div className="text-sm text-neutral-400 mt-1 whitespace-pre-line">{q.answer}</div>
            </div>
          ))}
        </div>
        <form onSubmit={save} className="border border-[color:var(--border)] p-4 space-y-3 h-fit">
          <input required placeholder="Pertanyaan" className="w-full bg-transparent border border-[color:var(--border)] p-2 text-sm" value={f.question} onChange={(e) => setF({ ...f, question: e.target.value })} />
          <textarea required rows={4} placeholder="Jawaban" className="w-full bg-transparent border border-[color:var(--border)] p-2 text-sm" value={f.answer} onChange={(e) => setF({ ...f, answer: e.target.value })} />
          <input type="number" placeholder="Order" className="w-full bg-transparent border border-[color:var(--border)] p-2 text-sm" value={f.order} onChange={(e) => setF({ ...f, order: e.target.value })} />
          <label className="text-xs"><input type="checkbox" checked={f.hidden} onChange={(e) => setF({ ...f, hidden: e.target.checked })} /> Sembunyikan</label>
          <button className="w-full bg-white text-black py-2 text-xs tracking-widest">{editing ? "UPDATE" : "TAMBAH"}</button>
        </form>
      </div>
    </div>
  );
}
